import { Injectable, OnDestroy } from '@angular/core';

import { Client } from '@stomp/stompjs';
import { BehaviorSubject } from 'rxjs';
import { AppService } from '@app/core/services/app.service';
import { BadgeNotification } from '@app/core/model/badge-notification.model';
import { PushNotification } from '@app/core/model/push-notification.model';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService implements OnDestroy {
  constructor(private appService: AppService) {}
  private client: Client;
  private readonly isBackendWebSocketEnabled = false;

  public connected: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public badgeNotifications$: BehaviorSubject<BadgeNotification[]> = new BehaviorSubject(null);
  public pushNotifications$: BehaviorSubject<PushNotification> = new BehaviorSubject(null);

  connect() {
    if (!this.isBackendWebSocketEnabled) {
      this.connected.next(false);
      return;
    }

    /*  this.client = this.appService.createWebSocketClient(9000);

    this.client.connectHeaders = {
      'X-Authorization': this.appService.get().token,
    };

    this.client.onConnect = () => {
      console.log('CONNECTED');
      this.connected.next(true);

      this.client.subscribe(
        '/user/queue/badge-notifications',
        (event) => {
          const changeIndicators = this.parseEvent<BadgeNotification[]>(event);
          this.badgeNotifications$.next(changeIndicators);
        },
        this.client.connectHeaders,
      );
      this.client.subscribe(
        '/user/queue/push-notifications',
        (event) => {
          const notification = this.parseEvent<PushNotification>(event);
          this.pushNotifications$.next(notification);
        },
        this.client.connectHeaders,
      );
    };

    this.client.onDisconnect = () => {
      console.log('DISCONNECTED');
      this.connected.next(false);
    };

    this.client.activate();*/
  }

  disconnect() {
    if (this.client) {
      this.client.deactivate();
    }
  }

  sendNotificationsViewed(notifications: BadgeNotification[]) {
    if (!this.isBackendWebSocketEnabled) {
      return;
    }

    if (navigator.onLine && this.client?.connected) {
      this.client.publish({
        destination: '/dwo/badge-notifications/viewed',
        body: JSON.stringify(notifications),
      });
    }
  }

  sendRefreshTriggered(notificationId: string) {
    if (!this.isBackendWebSocketEnabled) {
      return;
    }

    if (navigator.onLine && this.client?.connected) {
      const notification = {
        id: notificationId,
      } as BadgeNotification;
      this.client.publish({
        destination: '/dwo/badge-notifications/refreshed',
        body: JSON.stringify(notification),
      });
    }
  }

  parseEvent<T>(event: any): T {
    return JSON.parse(event.body) as T;
  }

  ngOnDestroy() {
    this.disconnect();
  }
}
